export default "__VITE_ASSET__095aa5b8__"